import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import all translations
import { et } from './locales/et';
import { en } from './locales/en';
import { ru } from './locales/ru';
import { ar } from './locales/ar';

const resources = {
  et: { translation: et },
  en: { translation: en },
  ru: { translation: ru },
  ar: { translation: ar }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'et', // will be changed by LanguageRouteHandler
    fallbackLng: 'et',
    debug: false,
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false
    }
  });

export default i18n;
